//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['type'],
    data: function data() {
        return {
            loading: true,
            headers: ['Name', { title: 'Amount', filter: 'toCurrency' }, 'Gl Account'],
            fields: ['fee', 'amount', 'full_name'],
            violations: []
        };
    },
    created: function created() {
        //Event.$on('get-violation', () => {});  //Empty call
        Event.$on("remove-violation", this.removeViolation);
        Event.$on('violation-updated-list', this.refresh);
        Event.$on("delete-entry", this.deleteEntry);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('get-violation');
        Event.$off('remove-violation');
        Event.$off('violation-updated-list');
        Event.$off('delete-entry');
    },
    mounted: function mounted() {},

    methods: {
        refresh: function refresh() {
            var $el = this;
            $el.loading = true;
            axios.get('/prototype/violation/violation-list').then(function (response) {
                if (response.data.length) {
                    $el.violations = response.data;
                }
                $el.loading = false;
            });
        },
        removeViolation: function removeViolation(item, idx) {
            Event.$emit("confirm-delete", item, "/prototype/violation/delete", "delete-entry", "Are you sure you want to delete this violation?", "Delete");
        },
        deleteEntry: function deleteEntry(item) {
            var $idx = this.violations.findIndex(function (i) {
                return i.id === item.id;
            });
            this.violations.splice($idx, 1);
            this.$snotify.success("The violation was deleted");
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/violation/ViolationList.vue
// module id = 8o/B
// module chunks = 0 1